import { useEffect, useState } from "react";
import { Heading } from "../../../design/heading";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";
import { useNavigate } from "react-router-dom";

export default function NylasCallbackPage() {
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) return;
    if (localStorage.getItem("isSyncingNylas") === "true") {
      return;
    }
    localStorage.setItem("isSyncingNylas", "true");

    let isMounted = true;

    const sync = async () => {
      if (!isMounted || syncing) return; // Prevent multiple sync attempts
      setSyncing(true);
      try {
        await httpsCallable(
          functions,
          "exchangeNylasAuthCode",
        )({
          code,
          redirectUri: window.location.origin + "/callback/nylas",
        });
        if (isMounted) {
          setSyncing(false);
          navigate("/scheduler");
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error syncing Nylas:", error);
          setError("Failed to sync Nylas. Please try again later.");
          setSyncing(false);
        }
      }
      localStorage.removeItem("isSyncingNylas");
    };

    sync();

    return () => {
      isMounted = false;
    };
  }, [code, syncing, navigate]);

  useEffect(() => {
    if (syncing) {
      navigate("/settings/integrations");
    }
  }, [navigate, syncing]);

  return (
    <div>
      <Heading>Nylas</Heading>
      {error && <div style={{ color: "red" }}>{error}</div>}
      {syncing ? <div>Syncing...</div> : <div>Ready to sync if needed.</div>}
    </div>
  );
}
